import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

const Hero = lazy(() => import('./components/Hero'));
const Portfolio = lazy(() => import('./components/Portfolio'));
const About = lazy(() => import('./components/About'));
const Contact = lazy(() => import('./components/Contact'));
const Travel = lazy(() => import('./components/Travel'));
const ResetPasswordPage = lazy(() => import('./components/ResetPasswordPage'));
const DownloadRedirect = lazy(() => import('./components/DownloadRedirect'));

function AppShell() {
  const location = useLocation();
  const isStandaloneRoute = ['/download', '/reset-password'].includes(location.pathname);

  return (
    <>
      {!isStandaloneRoute ? <Navbar /> : null}
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Contact />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/download" element={<DownloadRedirect />} />
        </Routes>
      </Suspense>
      {!isStandaloneRoute ? <Footer /> : null}
    </>
  );
}

const App = () => {
  return (
    <Router>
      <AppShell />
    </Router>
  );
};

export default App;
